import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false;

//引入全局css文件：
import './assets/css/reset.css';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueWechatTitle from 'vue-wechat-title'
Vue.use(ElementUI);
Vue.use(VueWechatTitle)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
